import { render, staticRenderFns } from "./SetConsult.vue?vue&type=template&id=206ad07b&scoped=true"
import script from "./SetConsult.vue?vue&type=script&lang=js"
export * from "./SetConsult.vue?vue&type=script&lang=js"
import style0 from "./SetConsult.vue?vue&type=style&index=0&id=206ad07b&prod&lang=scss"
import style1 from "./SetConsult.vue?vue&type=style&index=1&id=206ad07b&prod&lang=scss&scoped=true"
import style2 from "./SetConsult.vue?vue&type=style&index=2&id=206ad07b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ad07b",
  null
  
)

export default component.exports